<template>
    <div :class="phoneClass || 'add-dealer-container'">
        <content-header :title="isEdit ? $t('dealerPage.modification') : $t('dealerPage.new')">
        </content-header>
        <div class="dealer-content">
            <div class="floor-title">
                <span class="title">{{isEdit ? $t("dealerPage.modification") : $t("dealerPage.new")}}</span>
            </div>
            <div class="info-edit">
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('dealerPage.dealer_name')}}</p>
                        <el-input v-model="editForm.name" :placeholder="$t('dealerPage.dealer_name')"></el-input>
                    </div>
                    <div class="floor-block">
                        <p>{{$t('dealerPage.contact_person')}}</p>
                        <el-input v-model="editForm.contact_name" :placeholder="$t('dealerPage.contact_person')"></el-input>
                    </div>
                </div>
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('dealerPage.phone')}}</p>
                        <el-input v-model="editForm.phone" :placeholder="$t('dealerPage.phone')"></el-input>
                    </div>
                    <div class="floor-block">
                        <p>{{$t("dealerPage.empower")}}</p>
                        <el-input v-model="editForm.skf_auth_code" :placeholder="$t('dealerPage.empower')"></el-input>
                    </div>
                </div>
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('dealerPage.site')}}</p>
                        <el-cascader :options="regionData"
                                     v-model="pcc"
                                     style="width: 100%;"
                                     :placeholder="$t('dealerPage.site')"
                                     :props="regionProps"
                                     @change="regionChange">
                        </el-cascader>
                        <!-- <el-input v-model="editForm.site" :placeholder="$t('dealerPage.site')"></el-input> -->
                    </div>

                    <div class="floor-block">
                        <p>{{$t('dealerPage.address')}}</p>
                        <el-input v-model="editForm.address" :placeholder="$t('dealerPage.address')"></el-input>
                    </div>
                </div>
                <!--<div class="info-floor">-->
                    <!--<div class="floor-block" style="width:100%;">-->
                        <!--<p>{{$t('dealerPage.address')}}</p>-->
                        <!--<el-input v-model="editForm.address" :placeholder="$t('dealerPage.address')"></el-input>-->
                    <!--</div>-->
                <!--</div>-->
                <div class="inner-floor-title">
                    <h2>{{$t('dealerPage.account_password')}}</h2>
                </div>
                <div class="info-floor">
                    <div class="floor-block">
                        <p>{{$t('dealerPage.email')}}</p>
                        <el-input v-model="editForm.email" @change="check" :placeholder="$t('dealerPage.email')"></el-input>
                    </div>
                    <div class="floor-block" v-if="!isEdit">
                        <p>{{$t('dealerPage.password')}}</p>
                        <el-input v-model="editForm.password" type="password" :placeholder="$t('dealerPage.password')"></el-input>
                    </div>
                    <div v-else></div>
                </div>
                <!--<div class="check" ><span v-show="checkShow">{{msg}}</span></div>-->
                <div class="operation">
                    <el-button type="primary" @click="updateInfo">
                        {{$t('message.preserved')}}
                    </el-button>
                    <el-button  @click="$router.go(-1)">
                        {{$t('message.cancel')}}
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Core from "core/core";
import contentHeader from '../../components/content-header'
// import region from "core/region"
import {refresh} from "core/winSize"
// import axios from 'axios';
import REGION from '@/assets/ext/region-code.json';
export default {
    data() {
        return {
	        phoneClass: '',
            isEdit: false,
            regionData: [],
            pcc: [],
            regionProps: {
                value: 'name',
                label: 'name'
            },
            editForm: {
                name: '',          //服务商名称
                contact_name: '',       //联系人
                phone: '',         //电话
                skf_auth_code: '',         //id
                address: '',       //详细地址
                email: '',       //邮箱
                password: '',      //密码
                province: '',      //省
                city: '',          //市

            },
            dealerId: 0,
            dealerInfo: '',
            checkShow: false,
            msg: '',
            showpassword: false
        };
    },
    components: {
        contentHeader
    },
	created() {
		refresh(this,'phoneClass-add-dealer-container');
		window.onresize = function(){
			setTimeout(function(){
				refresh(this,'phoneClass-add-dealer-container');
			},10)
		};
	},
    mounted() {
	    this.initRegion()
        this.dealerId = this.$route.query.dealer_id || 0;
        if(this.dealerId) {
            this.isEdit = true;
            this.getDealerInfo()

        }else {
            this.isEdit = false;
        }

    },
    computed: {
    },
    methods: {
	    initRegion() {
            let list = REGION.zh
		    list.map(province => {
			    province.children.map(city => delete city.children)
		    })
		    this.regionData = list
	    },
        regionChange() {
            let [province, city, county] = this.pcc
            this.editForm.province = province
            this.editForm.city = city;

            // this.editForm.county = county
        },
        // name: '',          //服务商名称
        // contact: '',       //联系人
        // phone: '',         //电话
        // SKFid: '',         //id
        // address: '',       //详细地址
        // emall: '',       //邮箱
        // password: '',      //密码
        // province: '',      //省
        // city: '',          //市
        updateInfo() {
            let info = this.editForm;
            if (info.name && info.contact_name && info.phone && info.province && info.city &&
            info.address && info.skf_auth_code && info.email) {
	            if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(info.phone))){
		            this.$message.error('手机号码有误，请重填');
		            return false;
	            }
                this.check()
                if (!this.checkShow){
                    if(!this.dealerId){
                        if (info.password){
                            Core.Api.Agent.save(this.dealerId,info.name,info.contact_name,info.phone,info.province,info.city,
                                info.address,info.skf_auth_code,info.email,info.password).then(res => {
                                this.$message.success('新增成功');
                                this.$router.push({path:'/dealer'})
                                window.scrollTo(0,0);
                            })
                        } else {
                            this.$message.error('请填写密码');
                        }
                    } else {
                        Core.Api.Agent.save(this.dealerId,info.name,info.contact_name,info.phone,info.province,info.city,
                            info.address,info.skf_auth_code,info.email).then(res => {
                            this.$message.success('修改成功');
                            this.$router.push({path:'/dealer'})
                            window.scrollTo(0,0);
                        })
                    }
                }
            } else {
                    this.$message.error('请将资料填写完整');

                // console.log(info,"info");
                // for ( let key in info) {
                //     console.log(key+':'+info[key]);
                // }
            }


            // Core.Api.Agent.save(this.dealerId,info.name,info.contact,info.phone,info.province,info.city,
            // info.address,info.SKFid,info.emall,info.password).then( res=>{
            //     console.log(保存成功);
            // }).error(()=>{
            //     console.log(保存失败);
            // })
        },
        getDealerInfo() {
            Core.Api.Agent.detail(this.dealerId).then(res => {
                this.editForm = res;
                this.editForm.province = res.province
                this.editForm.city = res.city;
                this.pcc=[res.province,res.city]
            })
        },
        check(){
            if(this.editForm.email){
                let email = this.editForm.email;
	            let emailReg = Core.Const.EMAIL_REG
	            if( emailReg.test(email) ){
                    this.checkShow = false
                } else {
                    this.checkShow = true
                    this.$message.error('邮箱格式不正确');

                }
            } else {
                this.checkShow = true
                this.$message.error('请输入邮箱');

            }

        }
    },


};
</script>

<style scoped lang="scss">
@import '../../assets/style/mixin.scss';
.add-dealer-container {
    height: 100%;
    background-color: #F7F9FA;
    .dealer-content {
        margin: 30px 13vw;
        .floor-title {
            @include flex-sb;
            margin-bottom: 20px;
            .title {
                font-weight: 500;
                font-size: 20px;
                color: #363D42;
            }
            .my-button {
                border-color: #0F58D6;
                .icon {
                    width: 16px;
                    height: 16px;
                    vertical-align: middle;
                }
                .text {
                    font-size: 14px;
                    color: #0F58D6;
                    vertical-align: middle;
                    line-height: 20px;
                    margin-left: 6px;
                }
            }
        }
        .info-edit {
            .info-floor {
                margin-bottom: 20px;
                .floor-block {
                    display: inline-block;
                    width: calc(50% - 60px);
                    p {
                        margin-bottom: 6px;
                        font-size: 14px;
                        color: #7A8799;
                    }
                    &:first-child {
                        margin-right: 2.5vw;
                    }
                }
            }
            .inner-floor-title {
                padding: 10px 0;
                margin-bottom: 20px;
                border-bottom: #EBEDF3 1px solid;
                h2 {
                    font-size: 14px;
                    color: #363D42;
                }
            }
            .operation {
                margin-top: 30px;
                .el-button {
                    padding: 9px 42px;
                }
            }
        }
    }
    .check {
        color: red;
        font-size: 12px;
        position: relative;
        top: -15px;
        left: 15px;
        height: 20px;
    }
}
    .phoneClass-add-dealer-container {
        .dealer-content {
            width: 80%;
            margin: 30px auto;
            .floor-title {
                .title {
                    font-weight: 500;
                    font-size: 20px;
                    color: #363D42;
                }
                margin-bottom: 10px;
            }
            .info-edit {
                .floor-block {
                    margin-bottom: 7px;
                    p {
                        font-size: 14px;
                        color: #7A8799;
                        margin-bottom: 3px;
                    }
                }
            }
            .inner-floor-title {
                margin: 10px 0;
            }
            .operation {
                margin: 20px 0;
            }
        }
    }
</style>

<style lang="scss">
    .add-dealer-container {
        .info-edit {
            .info-floor {
                .el-input {
                    height: 40px;
                    .el-input__inner {
                        height: 40px;
                    }
                }
            }
        }

    }
    .phoneClass-add-dealer-container {
        .info-edit {
            .info-floor {
                .el-input {
                    height: 30px;
                    .el-input__inner {
                        height: 30px;
                    }
                }
            }
        }
    }
</style>
